// src/i18n/LangToggle.jsx
//
// The one language switcher (Hinglish | English) for field screens.
// It reads and writes the app-wide language through useLang(), so it can
// be dropped anywhere (login page, header, a page top bar) without passing
// props. Old callers that still pass lang / setLang keep working — those
// props are simply not needed any more (D-307).
//
// type="button" matters: on the login page this sits inside a <form>,
// and a button without a type would submit the form.

import { useLang } from "./useLang";

const OPTIONS = [
  { code: "hi", label: "Hinglish", border: "#16A34A", bg: "#DCFCE7", color: "#166534" },
  { code: "en", label: "English",  border: "#2563EB", bg: "#DBEAFE", color: "#1D4ED8" },
];

// defaultLang (optional, D-297 commit 5): the page's language before anyone
// chose one — must match the page's own useLang() call so the right button
// is highlighted. Field screens pass nothing ("hi").
export default function LangToggle({ defaultLang } = {}) {
  const { lang, setLang } = useLang(null, { defaultLang });

  return (
    <div style={{ display: "flex", gap: 6 }}>
      {OPTIONS.map((opt) => {
        const active = lang === opt.code;
        return (
          <button
            key={opt.code}
            type="button"
            onClick={() => setLang(opt.code)}
            style={{
              padding: "4px 10px",
              borderRadius: 8,
              fontSize: 11,
              fontWeight: 600,
              border: active ? `1px solid ${opt.border}` : "1px solid #D1D5DB",
              background: active ? opt.bg : "#fff",
              color: active ? opt.color : "#6B7280",
              cursor: "pointer",
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}